import React from 'react';
import {
  Database, BarChart2, FileText, Search, Brain, Users, Mail,
  Code2, TrendingUp, Shield, Cloud, Image, Mic, Video,
  MessageSquare, BookOpen, Bot, Wrench, Globe, CreditCard,
  ShoppingCart, Package, Truck, Layers, Zap, Building, Wallet,
} from 'lucide-react';

const KEYWORD_RULES = [
  { keys: ['sql', 'database', 'db', 'query'],          icon: Database,      from: '#4facfe', to: '#0052cc' },
  { keys: ['chart', 'graph', 'plot', 'visualization'],  icon: BarChart2,     from: '#f093fb', to: '#f5576c' },
  { keys: ['analytics', 'metric', 'kpi', 'trend'],      icon: TrendingUp,    from: '#fa709a', to: '#fee140' },
  { keys: ['ai', 'ml', 'neural', 'intelligence'],       icon: Brain,         from: '#667eea', to: '#764ba2' },
  { keys: ['bot', 'agent', 'assistant', 'chatbot'],     icon: Bot,           from: '#667eea', to: '#764ba2' },
  { keys: ['search', 'find', 'lookup'],                 icon: Search,        from: '#a18cd1', to: '#fbc2eb' },
  { keys: ['document', 'pdf', 'file', 'report'],        icon: FileText,      from: '#f6d365', to: '#fda085' },
  { keys: ['knowledge', 'rag', 'retrieval', 'book'],    icon: BookOpen,      from: '#43e97b', to: '#38f9d7' },
  { keys: ['image', 'photo', 'vision', 'ocr'],         icon: Image,         from: '#f093fb', to: '#f5576c' },
  { keys: ['audio', 'speech', 'voice', 'transcri'],    icon: Mic,           from: '#a18cd1', to: '#fbc2eb' },
  { keys: ['video', 'stream', 'camera'],                icon: Video,         from: '#fd746c', to: '#ff9068' },
  { keys: ['code', 'api', 'script', 'developer'],       icon: Code2,         from: '#0ba360', to: '#3cba92' },
  { keys: ['security', 'auth', 'encrypt'],              icon: Shield,        from: '#fd746c', to: '#ff9068' },
  { keys: ['cloud', 'aws', 'azure', 'storage'],        icon: Cloud,         from: '#89f7fe', to: '#66a6ff' },
  { keys: ['customer', 'user', 'client', 'profile'],   icon: Users,         from: '#f6d365', to: '#fda085' },
  { keys: ['email', 'mail', 'inbox'],                   icon: Mail,          from: '#4facfe', to: '#00f2fe' },
  { keys: ['chat', 'conversation', 'nlp', 'language'], icon: MessageSquare, from: '#43e97b', to: '#38f9d7' },
  { keys: ['finance', 'payment', 'billing', 'invoice'], icon: CreditCard,   from: '#4facfe', to: '#00f2fe' },
  { keys: ['invest', 'stock', 'portfolio', 'fund'],     icon: Wallet,        from: '#f6d365', to: '#fda085' },
  { keys: ['shop', 'ecommerce', 'order'],               icon: ShoppingCart,  from: '#fa709a', to: '#fee140' },
  { keys: ['logistics', 'shipping', 'delivery'],        icon: Truck,         from: '#4facfe', to: '#00f2fe' },
  { keys: ['workflow', 'pipeline', 'automation'],       icon: Layers,        from: '#a18cd1', to: '#fbc2eb' },
  { keys: ['global', 'web', 'internet'],                icon: Globe,         from: '#667eea', to: '#764ba2' },
  { keys: ['building', 'company', 'enterprise'],        icon: Building,      from: '#a18cd1', to: '#fbc2eb' },
  { keys: ['tool', 'plugin', 'integration'],            icon: Wrench,        from: '#fd746c', to: '#ff9068' },
  { keys: ['zap', 'trigger', 'event', 'webhook'],       icon: Zap,           from: '#fa709a', to: '#fee140' },
];

const match = (name = '') => {
  const lower = name.toLowerCase();
  for (const rule of KEYWORD_RULES) {
    if (rule.keys.some(k => lower.includes(k))) return rule;
  }
  return { icon: Bot, from: '#667eea', to: '#764ba2' };
};

/** Fallback shown when the real photo fails to load */
const GradientCardImage = ({ name = '' }) => {
  const { icon: Icon, from, to } = match(name);
  return (
    <div
      className="w-full h-full flex flex-col items-center justify-center gap-3"
      style={{ background: `linear-gradient(135deg, ${from} 0%, ${to} 100%)` }}
    >
      <div className="bg-white/20 rounded-2xl p-4 backdrop-blur-sm">
        <Icon className="w-12 h-12 sm:w-14 sm:h-14 text-white drop-shadow-md" strokeWidth={1.5} />
      </div>
      <span className="text-white/80 text-xs font-medium px-4 text-center line-clamp-1 max-w-[90%]">{name}</span>
    </div>
  );
};

export default GradientCardImage;
